var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alertBox.status)?_c('div',{staticClass:"o-alert",class:`o-alert--${_vm.alertBox.variant}`},[(_vm.hasSlot)?_vm._t("default"):_c('div',[_vm._v(_vm._s(_vm.$t(_vm.alertBox.text)))])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }